import { render, staticRenderFns } from "./ConfigLayout.vue?vue&type=template&id=9b0f9ebe&scoped=true"
import script from "./ConfigLayout.vue?vue&type=script&lang=js"
export * from "./ConfigLayout.vue?vue&type=script&lang=js"
import style0 from "./ConfigLayout.vue?vue&type=style&index=0&id=9b0f9ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0f9ebe",
  null
  
)

export default component.exports